module.exports = __webpack_public_path__ + "img/share1.d2fb75ff.png";